import { MenuEntry } from '@src/menu-entry.js';

export default MenuEntry.create()
    .setTitle('Rückzahlungen')
    .setChildren([
        MenuEntry.create()
            .setRoute('outgoing_payment_mollie_list'),
        MenuEntry.create()
            .setRoute('outgoing_payment_paypal_list'),
        MenuEntry.create()
            .setRoute('outgoing_payment_sepa_list'),
        MenuEntry.create()
            .setRoute('outgoing_payment_waiting_for_charge_list'),
        MenuEntry.create()
            .setRoute('outgoing_payment_failed_list'),
        MenuEntry.create()
            .setRoute('outgoing_payment_search'),
    ]);
